import React from 'react';
import PropTypes from 'prop-types';
import { UX2 } from '@wsb/guac-widget-core';

const SuggestedServicesLoader = ({ staticContent }) => {
  const { Card } = UX2.Group;
  const { Block, Label, Text, Heading } = UX2.Element;
  const services = [{}, {}, {}];

  return (
    <Block
      style={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column'
      }}
    >
      <Label
        style={{ fontSize: '24px', fontWeight: '400', marginBottom: '20px', maxWidth: '700px' }}
      >
        { staticContent.recommendServiceHeader ||
          'Boost Your Business: Add The Recommended Service to Accelerate Business Growth' }
      </Label>
      { services &&
        services.length &&
        services.map(service => (
          <Card
            key={ service.service_id }
            style={{
              width: '100%',
              display: 'flex',
              flex: 1,
              alignItems: 'center',
              paddingLeft: '20px',
              paddingRight: '20px',
              borderRadius: '7px',
              border: '1px solid #000',
              background: '#f5f5f5',
              minHeight: '70px',
              marginBottom: '10px',
              maxWidth: '600px'
            }}
          >
            <Block
              style={{
                width: '100%',
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                alignItems: 'flex-start'
              }}
            >
              <Heading
                style={{
                  color: 'black',
                  filter: 'blur(1px)'
                }}
              >
                <svg
                  width='258'
                  height='16'
                  viewBox='0 0 258 16'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <rect width='358' height='26' fill='#D9D9D9' />
                </svg>
              </Heading>
              <Text
                style={{
                  color: 'black',
                  filter: 'blur(1px)'
                }}
              >
                <svg
                  width='100'
                  height='16'
                  viewBox='0 0 100 16'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <rect width='558' height='26' fill='#D9D9D9' />
                </svg>
              </Text>
            </Block>

            <Block
              style={{
                display: 'flex',
                flex: 1,
                justifyContent: 'flex-end',
                borderRadius: '5px'
              }}
            >
              <svg
                width='69'
                height='31'
                viewBox='0 0 69 31'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <rect width='69' height='41' fill='#D9D9D9' />
              </svg>
            </Block>
          </Card>
        )) }
    </Block>
  );
};

SuggestedServicesLoader.propTypes = {
  staticContent: PropTypes.object
};

export default SuggestedServicesLoader;
